import Form from '@/components/Form/Form';

export default Form;
